import React from 'react';
import {connect} from 'react-redux';
import {setCurrentStep} from '../changePhoneNumberSlice';
import {ChangePhoneNumberStep} from '../Constant/Constant';
import CallBack from '../../../Shared/CallBack/CallBack';

const CallBackPage = (props) => {
  const handleGoBack = () => {
    props.setCurrentStep(ChangePhoneNumberStep.GeneralMessage);
  };

  return (
    <div className='callback-page step'>
      <CallBack
        subjectCode={props.changePhoneNumber.callBackCode}
        subTitle={'נציג יחזור אליך בהקדם להמשך טיפול'}
        contactNumber={props.changePhoneNumber.selectedAccount.productSubscriberNo}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
});

const mapDispatchToProps = {setCurrentStep};

export default connect(mapStateToProps, mapDispatchToProps)(CallBackPage);
